<template>
  <div class="acc-glass rounded-2xl p-5 border border-white/10 w-full">
    <div class="text-lg font-extrabold tracking-tight">Налаштування · Приватність</div>
    <div class="mt-4 space-y-3">
      <label class="flex items-center justify-between rounded-xl border border-white/10 bg-white/5 px-3 py-2">
        <span class="text-sm text-white/85">Публічний профіль</span>
        <input v-model="form.public_profile" type="checkbox">
      </label>
      <button type="button" class="acc-btn-primary w-full justify-center" :disabled="saving" @click="save">
        {{ saving ? 'Збереження...' : 'Зберегти налаштування' }}
      </button>
      <div v-if="message" class="text-xs text-emerald-300">{{ message }}</div>
      <div v-if="error" class="text-xs text-red-300">{{ error }}</div>
    </div>
  </div>
</template>

<script lang="js">
import axios from 'axios';

export default {
  props: {
    profile: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      form: {
        public_profile: true,
      },
      saving: false,
      message: '',
      error: '',
    };
  },
  watch: {
    profile: {
      immediate: true,
      handler(value) {
        const settings = value?.settings || {};
        this.form.public_profile = settings.public_profile !== false;
      },
    },
  },
  methods: {
    async save() {
      this.saving = true;
      this.message = '';
      this.error = '';
      try {
        const { data } = await axios.put('/api/account/profile/privacy', {
          public_profile: this.form.public_profile,
        });
        this.message = data?.message || 'Збережено.';
      } catch (e) {
        this.error = e?.response?.data?.message || 'Не вдалося зберегти.';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
